export const placementsToOutbrainWidgets: Record<string, string> = {}
export const outbrainMixins: Record<string, Partial<OutbrainProps>> = {}
